import { ActionControllerEventName, ResourcesManager, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { Vector3 } from 'three';
import { PickingControllerEvents } from "@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController";
import { PreparationPickingObjects } from "../../utils/PreparationPickingObjects";
export default class FocusHolderModule extends ViewerModule {
    constructor(level) {
        super();
        this.__inited = false;
        this.pointerController = Viewer.pointerController;
        this.model = ResourcesManager.getModel('micropipette_holder_1').clone();
        this.addObject(this.model);
        this.level = level;
    }
    init() {
        this.testTube = ResourcesManager.getModel('test_tube_red').clone();
        this.testTube.position.set(0, .16, 0);
        this.addObject(this.testTube);
    }
    createClickEvent() {
        let callback;
        this.actionController.on(ActionControllerEventName.click, this.uiObject, callback = () => {
            if (Viewer.controls.zController)
                return;
            if (!this.level.interaction)
                return;
            this.fire('holder_clicked');
            this.actionController.off(ActionControllerEventName.click, this.uiObject, callback);
        });
        if (this.level.lobby.app.zSpacePickingController) {
            const pipetteUiObject = this.level.instruments.pipette.uiObject;
            PreparationPickingObjects.saveObjectState(pipetteUiObject);
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, pipetteUiObject, () => {
                const distanceToFocusHolder = this.level.instruments.pipette.model.getWorldPosition(new Vector3()).distanceTo(new Vector3(-23.7, -16.76, -9.6));
                if (distanceToFocusHolder < 1.3) {
                    this.fire('holder_clicked');
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, pipetteUiObject);
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, pipetteUiObject);
                }
                else {
                    PreparationPickingObjects.flyObjectToPrevState(pipetteUiObject, 0);
                }
                setTimeout(() => pipetteUiObject.traverse(el => {
                    if (el.userData.oldRaycast)
                        el.raycast = el.userData.oldRaycast;
                }));
                this.actionController.off(ActionControllerEventName.click, this.uiObject, callback);
            });
        }
    }
    setEmptyTube() {
        this.disposeObject(this.testTube);
        this.emptyTestTube = ResourcesManager.getModel('test_tube_empty').clone();
        this.emptyTestTube.position.set(0, .16, 0);
        this.addObject(this.emptyTestTube);
    }
}
